import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=4fa53eec&scoped=true&"
import script from "./OrderData.vue?vue&type=script&lang=js&"
export * from "./OrderData.vue?vue&type=script&lang=js&"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=4fa53eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa53eec",
  null
  
)

export default component.exports